"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _List = require("../../List");

var _Popover = _interopRequireDefault(require("../../Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Menu = (0, _autobindDecorator["default"])(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(Menu, _React$Component);

  function Menu() {
    (0, _classCallCheck2["default"])(this, Menu);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).apply(this, arguments));
  }

  (0, _createClass2["default"])(Menu, [{
    key: "getListRef",
    value: function getListRef() {
      return this.listRef;
    }
  }, {
    key: "onClick",
    value: function onClick(e) {
      e.preventDefault();

      if (this.props.onClick) {
        this.props.onClick(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          closeOnSelect = _this$props.closeOnSelect,
          open = _this$props.open,
          onClose = _this$props.onClose,
          onSelect = _this$props.onSelect,
          placement = _this$props.placement,
          _this$props$role = _this$props.role,
          role = _this$props$role === void 0 ? 'menu' : _this$props$role,
          style = _this$props.style,
          trapFocus = _this$props.trapFocus,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["children", "className", "closeOnSelect", "open", "onClose", "onSelect", "placement", "role", "style", "trapFocus"]);
      delete otherProps.target;
      delete otherProps.onClick;
      return _react["default"].createElement(_Popover["default"], {
        isDialog: false,
        placement: placement,
        open: open,
        onClose: onClose,
        style: _objectSpread({}, style, {
          overflowY: 'auto'
        }),
        trapFocus: trapFocus
      }, _react["default"].createElement(_List.List, (0, _extends2["default"])({
        ref: function ref(l) {
          return _this.listRef = l;
        },
        role: role,
        className: className,
        onClick: this.onClick
      }, otherProps), _react["default"].Children.map(children, function (child) {
        return _react["default"].cloneElement(child, {
          onSelect: onSelect,
          closeOnSelect: closeOnSelect
        });
      })));
    }
  }]);
  return Menu;
}(_react["default"].Component), (0, _defineProperty2["default"])(_class2, "displayName", 'Menu'), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /**
   * Location of the menu in relation to the element triggering it. If used
   * with overlay trigger and there isn't enough room for the menu in that
   * position, it will make a limited attempt to find a new position.
   */
  placement: _propTypes["default"].oneOf(['bottom', 'bottom left', 'bottom right', 'top', 'top left', 'top right', 'left', 'left top', 'left bottom', 'right', 'right top', 'right bottom']),

  /**
   * Whether the menu is opened.
   */
  open: _propTypes["default"].bool,

  /**
   * Callback when menu closes.
   */
  onClose: _propTypes["default"].func,

  /**
   * Callback when menu item is selected.
   */
  onSelect: _propTypes["default"].func,

  /**
   * String for extra class names to add to the menu
   */
  className: _propTypes["default"].string,

  /**
   * True by default, this keeps focus within children of this component.
   * When disabled, focus may leave this component.
   */
  trapFocus: _propTypes["default"].bool,

  /**
   * The WAI-ARIA role for the menu. Defaults to "menu", but could be "listbox" depending on context.
   */
  role: _propTypes["default"].oneOf(['menu', 'listbox'])
}), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  trapFocus: true
}), _temp)) || _class;

exports["default"] = Menu;